import { Link } from 'react-router-dom';
import { useInView } from '@/hooks/useInView';

export default function ChannelSection() {
  const { ref, inView } = useInView();

  const anim = (inView: boolean) =>
    `transition-all duration-700 ease-out ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`;

  return (
    <section className="min-h-[100svh] flex items-center py-20 md:py-28 px-6 md:px-10 bg-accent-50">
      <div ref={ref} className={`max-w-6xl mx-auto text-center w-full ${anim(inView)}`}>
        <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight mb-4">
          山頂視角合作購書通路
        </h2>
        <p className="text-base text-foreground-500 max-w-2xl mx-auto leading-relaxed mb-10">
          出版書籍可透過以下合作通路查找與購買，實際資訊以各通路頁面為準。
        </p>

        <div className="flex flex-wrap justify-center gap-4">
          <Link
            to="/stores"
            className="px-6 py-3 bg-primary-500 text-white font-label font-medium text-base rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
          >
            查看合作購書通路
          </Link>
          <a
            href="https://www.books.com.tw/web/sys_puballb/books/?pubid=daiho43"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="px-6 py-3 bg-background-100 text-foreground-950 font-label font-medium text-base rounded-full hover:bg-background-200 border border-background-300 transition-all duration-300 whitespace-nowrap"
          >
            前往博客來品牌書目
          </a>
        </div>

        <p className="text-base text-foreground-500 mt-6 max-w-2xl mx-auto leading-relaxed">
          若在特定平台找不到書籍，可先至崧博出版書籍資料庫確認書名與ISBN。
        </p>
      </div>
    </section>
  );
}